import angular from 'angular';
import template from './template.html';
import { VIEW_STATE, EDIT_STATE, summernoteOptions } from '../../../../bulk-message/summernote-options';
import './style.scss';

export class PreferencesSection {
    canEdit = false;
    isValid = true;
    preferences = [''];
    innerPreferences = '';
    summernoteOptions = summernoteOptions;
    preferenceEditState = VIEW_STATE;

    /* @ngInject */
    constructor($sce) {
        this.$sce = $sce;
    }

    setState(state) {
        this.preferenceEditState = state;
    }

    $onChanges() {
        const { isValid,canEdit } = this;
        this.resetPreferences();

        if (!isValid && canEdit) {
            this.setState(EDIT_STATE);
        }
    }

    onEditButtonClick() {
        this.setState(EDIT_STATE);
    }

    onCancelButtonClick() {
        this.setState(VIEW_STATE);
        this.resetPreferences();
    }

    onSaveButtonClick() {
        this.setState(VIEW_STATE);
        this.onPreferencesChanged({ preferences: [this.innerPreferences] });
    }

    resetPreferences() {
        const { preferences = [], $sce } = this;

        this.innerPreferences = angular.copy(preferences[0]);
        this.formattedPreferences = $sce.trustAsHtml(this.innerPreferences);
    }
}

export const PreferencesSectionConfiguration = {
    template,
    controller: PreferencesSection,
    bindings: {
        preferences: '<',
        canEdit: '<',
        isValid: '<',
        onPreferencesChanged: '&',
    },
    controllerAs: 'preferencesSectionCtrl'
};

angular
    .module('TALENYA-FE')
    .component('candidatePreferencesSection', PreferencesSectionConfiguration);
